import {
    FiDatabase,
    FiBriefcase,
    FiShield,
    FiMessageSquare,
    FiSend,
    FiLayout,
    FiHelpCircle,
    FiCpu,
    FiShieldOff,
    FiUser,
    FiDollarSign,
    FiBox,
    FiAlertTriangle,
    FiSearch,
    FiTrash,
    FiPlus,
    FiCopy,
    FiSettings,
    FiCheck,
    FiInfo,
    FiBell,
    FiGrid,
    FiHash,
    FiGitBranch,
    FiPlusSquare,
    FiUpload,
    FiMail,
    FiEye,
    FiCode,
    FiMaximize,
    FiMinimize,
    FiExternalLink,
    FiActivity,
    FiServer,
    FiGlobe,
    FiPieChart,
    FiAlertCircle,
    FiLogIn,
    FiLogOut,
    FiFile,
    FiDownload,
    FiChevronRight,
    FiChevronLeft,
    FiChevronsLeft,
    FiCheckSquare,
    FiXSquare,
    FiRotateCcw,
    FiCommand,
    FiMenu, FiEdit
} from "react-icons/fi";
import {IoArrowBackSharp, IoExitOutline, IoFilterSharp, IoLogoWhatsapp} from "react-icons/io5"
import {ImTextColor} from "react-icons/im";
import {BiBlock} from "react-icons/bi";
import {TbMessageCode} from "react-icons/tb";
import { IoMdImage } from "react-icons/io";

const Icon = ({name, ...rest}) => {
    const defaultIcon = <FiHelpCircle {...rest} />
    const icons = {
        enterprise  : <FiBriefcase {...rest} />,
        audience    : <FiDatabase {...rest} />,
        blacklist   : <FiShield {...rest} />,
        sms         : <FiMessageSquare {...rest} />,
        send        : <FiSend {...rest} />,
        landing     : <FiLayout {...rest} />,
        journey     : <FiCpu {...rest} />,
        role        : <FiShieldOff {...rest} />,
        user        : <FiUser {...rest} />,
        plan        : <FiDollarSign {...rest} />,
        account     : <FiBox {...rest} />,
        alert       : <FiAlertTriangle {...rest} />,
        search      : <FiSearch {...rest} />,
        delete      : <FiTrash {...rest} />,
        plus        : <FiPlus {...rest} />,
        copy        : <FiCopy {...rest} />,
        settings    : <FiSettings {...rest} />,
        check       : <FiCheck {...rest} />,
        check2      : <FiCheckSquare {...rest} />,
        info        : <FiInfo {...rest} />,
        notification: <FiBell {...rest} />,
        dashboard   : <FiGrid {...rest} />,
        field       : <FiHash {...rest} />,
        segment     : <FiGitBranch {...rest} />,
        plus2       : <FiPlusSquare {...rest} />,
        upload      : <FiUpload {...rest} />,
        download    : <FiDownload {...rest} />,
        email       : <FiMail {...rest} />,
        preview     : <FiEye {...rest} />,
        code        : <FiCode {...rest} />,
        maximize    : <FiMaximize {...rest} />,
        minimize    : <FiMinimize {...rest} />,
        elink       : <FiExternalLink {...rest} />,
        filter      : <IoFilterSharp {...rest} />,
        event       : <FiActivity {...rest} />,
        sftp        : <FiServer {...rest} />,
        ws          : <FiGlobe {...rest} />,
        stats       : <FiPieChart {...rest} />,
        exclamation : <FiAlertCircle {...rest} />,
        logout      : <FiLogOut {...rest} />,
        login       : <FiLogIn {...rest} />,
        invoice     : <FiFile {...rest} />,
        next        : <FiChevronRight {...rest}/>,
        prev        : <FiChevronLeft {...rest} />,
        forward     : <FiChevronsLeft {...rest} />,
        backward    : <FiChevronsLeft {...rest} />,
        back        : <IoArrowBackSharp {...rest}/>,
        exit        : <IoExitOutline {...rest} />,
        disalow     : <BiBlock {...rest} />,
        activity    : <FiActivity {...rest} />,
        close       : <FiXSquare {...rest} />,
        reload      : <FiRotateCcw {...rest} />,
        command     : <FiCommand {...rest} />,
        menu        : <FiMenu {...rest} />,
        edit        : <FiEdit {...rest} />,
        text        : <ImTextColor {...rest} />,
        whatsapp    : <IoLogoWhatsapp  {...rest} />,
        rcs         : <TbMessageCode  {...rest} />,
        image       : <IoMdImage  {...rest} />,
    }


    return icons[name] === undefined ? defaultIcon : icons[name]

}

export default Icon;